export default "__VITE_ASSET__HbEZPoc___"